import { Injectable } from '@angular/core'
import { environment } from '../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../models/response.model'
@Injectable({
  providedIn: 'root',
})
export class ContextService {
  private baseUrl = environment.baseUrl
  private resource: string = 'contexto-medicao'

  constructor(private httpClient: HttpClient) {}

  public createContext(
    model: any,
    // model: CreateLegalEntityClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/create`,
      model,
    )
  }

  public editContext(
    model: any,
    // model: EditLegalEntityClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.put<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/update`,
      model,
    )
  }

  public deleteContext(
    id: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.delete<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/delete/${id}`)
  }

  public listPagedContext(
    page: number,
    rows: number = 10,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/paginated?page=${page}&per_page=${rows}`,
    )
  }

  public listPagedLegalEntityClientBySubClientId(
    subClientId: number,
    page: number,
    rows: number = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated/associado-subcliente/${subClientId}?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listPagedNotLegalEntityClientBySubClientId(
    subClientId: number,
    page: number,
    rows: number = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated/desassociado-subcliente/${subClientId}?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listContext(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/list`,
    )
  }

  public getLegalEntityClientbyId(
    id: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${id}`,
    )
  }

  public searchPagedAdmin(
    page: number,
    rows: number = 10,
    model: any,
  ): Observable<ResponseRequestModel> {
    if(model.nome === undefined){
      model.nome_principal = ""
    }
    if(model.cpf === undefined){
      model.cpf = ""
    }
    if(model.cnpj === undefined){
      model.cnpj = ""
    }
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/paginated?page=${page}&per_page=${rows}&nome=${model.nome_principal}&cpf=${model.cpf}&cnpj=${model.cnpj}`,
    )
  }

  public searchPagedLegalEntityClientAssociateBySubClient(
    page: number,
    rows: number = 15,
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated/associado-subcliente?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }
}
